import React, { useState } from "react";

export default function HowToBuyNFT() {
  const [imageSrc, setImageSrc] = useState("assets/img/one/step-01.png");

  const handleMouseEnter = (newSrc) => {
    setImageSrc(newSrc);
  };
  return (
    <>
      <div className="tp-award-area ab-award-style pt-120">
        <div className="container container-1480">
          <div className="row">
            <div className="col-xxl-12 col-xl-12">
              <div className="">
                <h2 className="tp-section-title-90 tp_text_invert tp_fade_bottom text-yellow-new">
                  How to Buy Your Kryptogram NFT
                </h2>
                <br />
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
              <div className="tp-award-list-thu text-center">
                <div className=" bg-gray-500 flex items-center justify-center">
                  <img
                    src={imageSrc}
                    alt="Preview"
                    className="max-w-full max-h-full"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-8 col-md-12 pt-4">
              <div className="tp-award-list-wrap">
                <div id="tp-award-thumb"></div>
                {[
                  {
                    step: "Step 1",
                    src: "assets/img/one/step-01.png",
                    label:
                      "Ensure your wallet is connected (MetaMask, Trust Wallet, etc.)",
                  },
                  {
                    step: "Step 2",
                    src: "assets/img/one/step-02.png",
                    label: "Select the number of NFTs you wish to purchase.",
                  },
                  {
                    step: "Step 3",
                    src: "assets/img/one/step-03.png",
                    label: "Choose your payment method",
                  },
                  {
                    step: "Step 4",
                    src: "assets/img/one/step-04.png",
                    label: "Click (Buy Now) and confirm the transaction.",
                  },
                  {
                    step: "Step 5",
                    src: "assets/img/one/step05.png",
                    label:
                      "Your NFT will be instantly sent to your wallet upon successful purchase",
                  },
                ].map((item, index) => {
                  return (
                    <div
                      className="tp-award-list-item d-flex  align-items-center justify-content-between active tp_fade_bottom "
                      rel="tp-award-list-thumb-1"
                      key={index}
                      onMouseEnter={() => handleMouseEnter(item.src)}
                    >
                      <div className="tp-award-list-content-left d-flex align-items-center">
                        <span>{item?.step}</span>
                        <p>{item?.label}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
